import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {DatabaseOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import InStockTypeSelect from "../../piece/InStockTypeSelect";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <DatabaseOutlined/> In-stock
            </FilterButton>
            <Modal
                title='In-stock Filter'
                visible={visible}
                open={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            inStockFilter: {
                                text: 'In-stock',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <InStockTypeSelect
                    placeholder='Please select in stock type'
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}